import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdOutlineExitToApp } from 'react-icons/md';
import { FaUserGear } from 'react-icons/fa6';
import { useAuth } from '../../context/AuthContext';
import { Avatar } from '@heroui/react';
import { handleLogout } from './auth/apiAuth';

export const HeaderAuthDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { user, isAuthenticated, profilePicture, role } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) return null;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const logout = () => {
    handleLogout();
  };

  return (
    <div
      className="relative inline-block text-left"
      ref={dropdownRef}
      onClick={() => setIsOpen((prev) => !prev)}
    >
      {/* TRIGGER - Reduced size for Compact UI */}
      <div className="cursor-pointer p-1">
        <Avatar
          className="w-6 h-6 text-tiny"
          src={profilePicture || undefined}
        />
      </div>

      {/* DROPDOWN MENU */}
      {isOpen && (
        <div className="absolute right-0 z-50 pt-1 w-56 origin-top-right">
          {/* Menu Container - Reduced width from w-64 to w-56 */}
          <div className="rounded-lg border border-gray-100 bg-white shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
            {/* User Header - More Compact */}
            <div className="px-3 py-2 bg-gray-50/50 border-b border-gray-100 text-start">
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-tight">
                user Role
              </p>
              <p className="text-xs font-semibold text-gray-700 truncate capitalize">
                {role}
              </p>
            </div>

            <div className="px-3 py-2 bg-gray-50/50 border-b border-gray-100 text-start">
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-tight">
                Account
              </p>
              <p className="text-xs font-semibold text-gray-700 truncate">
                {user?.email}
              </p>
            </div>

            {/* Profile Settings — centralized across Customer & Provider portals */}
            <div className="border-b border-gray-100">
              <button
                onClick={() => {
                  setIsOpen(false);
                  navigate('/customer/customer-profile');
                }}
                className="flex items-center w-full px-3 py-2.5 text-xs text-teal-700 font-semibold hover:bg-teal-50 transition-colors"
              >
                <FaUserGear className="mr-2 text-base" />
                Profile Settings
              </button>
            </div>

            {/* LOGOUT */}
            <div>
              <button
                onClick={logout}
                className="flex items-center w-full px-3 py-2 text-xs text-red-500 hover:bg-red-50 transition-colors"
              >
                <MdOutlineExitToApp className="mr-2 text-lg" />
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
